import { render } from "./profile.vue?vue&type=template&id=352d3bff&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"

import "./profile.vue?vue&type=style&index=0&id=352d3bff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352d3bff"],['__file',"src/views/profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "352d3bff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('352d3bff', __exports__)) {
    api.reload('352d3bff', __exports__)
  }
  
  module.hot.accept("./profile.vue?vue&type=template&id=352d3bff&scoped=true", () => {
    api.rerender('352d3bff', render)
  })

}


export default __exports__